import { render, staticRenderFns } from "./purchaseInfo.vue?vue&type=template&id=dcf7569a&scoped=true&"
import script from "./purchaseInfo.vue?vue&type=script&lang=js&"
export * from "./purchaseInfo.vue?vue&type=script&lang=js&"
import style0 from "./purchaseInfo.vue?vue&type=style&index=0&id=dcf7569a&lang=scss&scoped=true&"
import style1 from "./purchaseInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf7569a",
  null
  
)

export default component.exports